import React, {Component} from 'react';
import { Trans } from 'react-i18next';

import Scale from './Scale.jsx';
import Orientation from './Orientation.jsx'
import Cartela from './Cartela.jsx'
import CellDensity from './CellDensity.jsx'
import Grid from './Grid.jsx';

import i18n from '../resources/i18n';

import IMG_PAISAJE_COLOR from '../img/paisaje-color.svg';
import IMG_PAISAJE_GRIS from '../img/paisaje-gris.svg';
import IMG_RETRATO_COLOR from '../img/retrato-color.svg';
import IMG_RETRATO_GRIS from '../img/retrato-gris.svg';

import IMG_CARTELA_V from '../img/Cartela_V.svg';
import IMG_CARTELA_V_GRIS from '../img/Cartela_V_gris.svg';
import IMG_CARTELA_H from '../img/Cartela_H.svg';
import IMG_CARTELA_H_GRIS from '../img/Cartela_H_gris.svg';

import IMG_COORDENADAS_COLOR from '../img/coordenadas.svg';
import IMG_COORDENADAS_GRIS from '../img/coordenadas-gris.svg';
import IMG_CUADRICULA_COLOR from '../img/cuadricula.svg';
// import IMG_CUADRICULA_GRIS from '../img/cuadricula-gris.svg';
import IMG_CUADRICULA_GRIS from '../img/cuadricula-gris.png';
import IMG_1KM_COLOR from '../img/Cuadricula_1.svg';
import IMG_1KM_GRIS from '../img/Cuadricula_1-gris.svg';
import IMG_2KM_COLOR from '../img/Cuadricula_2.svg';
import IMG_2KM_GRIS from '../img/Cuadricula_2-gris.svg';
import IMG_5KM_COLOR from '../img/Cuadricula_5.svg';
import IMG_5KM_GRIS from '../img/Cuadricula_5-gris.svg';

class OptionMapSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstRow: '25K',
      secondRow: '50K',
      activeRow: this.props.activeRow,
      orientation: this.props.orientation,
      orientationIMGPaisajeColor: IMG_PAISAJE_COLOR,
      orientationIMGPaisajeGris: IMG_PAISAJE_GRIS,
      orientationIMGRetratoColor: IMG_RETRATO_COLOR,
      orientationIMGRetratoGris: IMG_RETRATO_GRIS,
      cartelaVertical: IMG_CARTELA_V,
      cartelaVerticalGris: IMG_CARTELA_V_GRIS,
      cartelaHorizontal: IMG_CARTELA_H,
      cartelaHorizontalGris: IMG_CARTELA_H_GRIS,
      coordinatesIMGColor: IMG_COORDENADAS_COLOR,
      coordinatesIMGGris: IMG_COORDENADAS_GRIS,
      gridIMGColor: IMG_CUADRICULA_COLOR,
      gridIMGGris: IMG_CUADRICULA_GRIS,
      oneKMColor: IMG_1KM_COLOR,
      oneKMGris: IMG_1KM_GRIS,
      twoKMColor: IMG_2KM_COLOR,
      twoKMGris: IMG_2KM_GRIS,
      fiveKMColor: IMG_5KM_COLOR,
      fiveKMGris: IMG_5KM_GRIS,
      cellDensity: this.props.cellDensity,
      radioButtonOneChecked: 'checked',
      radioButtonTwoChecked: 'checked',
      parentState: this.props.parentState
    };
    this.showHelpGrid = false;
    this.enableVertical = this.props.parentState.verticalCartela || false;
  }

  setStateGlobal = (state, event, value) => {
    const {setParentState} = this.props;
    setParentState(state, event);
  }

  configAutoScale(scale) {
    if (this.props.pluginEdition.currentScale !== scale) {
      this.props.pluginEdition.currentScale = scale;
      window.mapJs.getLayers().filter(l=>(l.legend && l.legend.endsWith('(Líneas)')) || l.impl_.name === '__draw__' || l.from_parameters || l.layerAddedByEditionTools).forEach(l=>l.getFeatures().forEach(f=>{
        f.impl_.olFeature_.changed();
      }));
    }
  }

  setActiveRow = (event) => {
    let {parentState} = this.props;
    if (event.target.value === 'secondRow') {
      this.configAutoScale(50);
      this.props.actionScale('1:50.000'); //, 'secondRow'
      parentState.cellDensity = "5";
      if (this.showHelpGrid) {
        window.grid25Layer.setVisible(false);
        window.grid50Layer.setVisible(true);
      }

      window.mapJs.setMaxZoom(15);
      window.mapJs.removeLayers(window.mapJs.getLayers().find(l=>l.impl_.name === 'MTN'));
      window.mapJs.addLayers('TMS*MTN*https://tms-mapa-raster.ign.es/1.0.0/mapa-raster/{z}/{x}/{-y}.jpeg*true*false*14');
    } else {
      this.configAutoScale(25);
      this.props.actionScale('1:25.000');//, 'firstRow'
      parentState.cellDensity = "1";
      if (this.showHelpGrid) {
        window.grid50Layer.setVisible(false);
        window.grid25Layer.setVisible(true);
      }

      window.mapJs.setMaxZoom(18);
      window.mapJs.removeLayers(window.mapJs.getLayers().find(l=>l.impl_.name === 'MTN'));
      window.mapJs.addLayers('TMS*MTN*https://tms-mapa-raster.ign.es/1.0.0/mapa-raster/{z}/{x}/{-y}.jpeg*true*false*16');
    }
    this.setStateGlobal(parentState);
  }

  toggleHelpGrid = () => {
    if(this.showHelpGrid){
      window.grid50Layer.setVisible(false);
      window.grid25Layer.setVisible(false);
    }else{
      if(this.props.parentState.activeRow === 'secondRow'){
        window.grid50Layer.setVisible(true);
      }else{
        window.grid25Layer.setVisible(true);
      }
    }
    this.showHelpGrid = !this.showHelpGrid
    this.setStateGlobal(this.props.parentState);
  }

  toggleVertical = (respuesta) => {
    if(respuesta === 'medium Cartela'){
      if(this.enableVertical){
        this.enableVertical = false;
        this.props.parentState.verticalCartela = false;
        this.setStateGlobal(this.props.parentState);
        this.props.actionVertical(this.enableVertical);
      }
    }else{
      if (!this.enableVertical){
        this.enableVertical = true;
        this.props.parentState.verticalCartela = true;
        this.setStateGlobal(this.props.parentState);
        this.props.actionVertical(this.enableVertical);
      }
    }
  }

  changeSelectedScale = (option) => {
    let {parentState} = this.props;
    switch (option) {
      case '40K':
        if (parentState.activeRow === 'secondRow') {
          parentState.scale = '1:40.000';
          this.configAutoScale(40);
        }
        break;
      case '20K':
        if (parentState.activeRow === 'firstRow') {
          parentState.scale = '1:20.000';
          this.configAutoScale(20);
        }
        break;
      case '30K':
        if (parentState.activeRow === 'firstRow') {
          parentState.scale = '1:30.000';
          this.configAutoScale(30);
        }
        break;
      case '50K':
        if (parentState.activeRow === 'secondRow') {
          parentState.scale = '1:50.000';
          this.configAutoScale(50);
        }
        break;
      case '60K':
        if (parentState.activeRow === 'secondRow') {
          parentState.scale = '1:60.000';
          this.configAutoScale(60);
        }
        break;
      default:
        if (parentState.activeRow === 'firstRow') {
          parentState.scale = '1:25.000';
          this.configAutoScale(25);
        }
        break;
    }

    this.props.actionScale(parentState.scale);//, option, parentState.activeRow
    if (parentState.scale === '1:20.000' || parentState.scale === '1:25.000') {
      parentState.cellDensity = "1";
    } else if (parentState.scale === '1:30.000' || parentState.scale === '1:40.000'){
      parentState.cellDensity = "2";
    } else {
      parentState.cellDensity = "5";
    }
    this.setStateGlobal(parentState);

  }

  changeSelectedOrientation = (option) => {
    let {parentState} = this.props;
    parentState.previousOrientation = parentState.orientation;
    parentState.orientation = option;
    if(parentState.orientation === 'Paisaje'){
      this.enableVertical = false;
      parentState.verticalCartela = false;
    }
    this.setStateGlobal(parentState);
    this.props.actionOrientation(parentState.orientation);
  }

  changeSelectedCellDensity = (option) => {
    let {parentState} = this.props;
    parentState.cellDensity = option;
    this.setStateGlobal(parentState);
  }

  updateFramesValues = (option) => {
    let {parentState} = this.props;

    if (option === 'gridC') {
      if (parentState.gridFrame === 'active') {
        parentState.gridFrame = '';
      } else {
        parentState.gridFrame = 'active';
      }
    } else if (option === 'cuadriculaC') {
      if (parentState.coordinatesFrame === 'active') {
        parentState.coordinatesFrame = '';
      } else {
        parentState.coordinatesFrame = 'active';
      }
    }
    this.setStateGlobal(parentState);

  }

  changeSelectedGrid = (e) => {
    this.setState({
      [e.target.name]: e.target.checked === false
        ? ""
        : "checked"
    });
  }

  render() {

    const {asideClassName, classPanelButton, classPanelContent, parentState} = this.props;
    const {
      orientationIMGPaisajeColor,
      orientationIMGPaisajeGris,
      orientationIMGRetratoColor,
      orientationIMGRetratoGris,
      cartelaVertical,
      cartelaVerticalGris,
      cartelaHorizontal,
      cartelaHorizontalGris,
      coordinatesIMGColor,
      coordinatesIMGGris,
      gridIMGColor,
      gridIMGGris,
      oneKMColor,
      oneKMGris,
      twoKMColor,
      twoKMGris,
      fiveKMColor,
      fiveKMGris,
    } = this.state;
    return (<aside className={asideClassName}>
      <div className={classPanelButton}>
        <div className='open'>
          <i className='fas fa-arrow'></i>
        </div>
      </div>

      <div className={classPanelContent}>
        {/* PRODUCTO */}
        <React.Fragment>
        <h2 className="h2Custom"><Trans i18nKey="step1.product">Producto</Trans></h2>
        <div className="scale first-step" style={{position:"relative"}}>

          <div className="radiobutton-row center scaleOption">
            <span><input type="radio" id="opt1" name="drone" value="firstRow" checked={parentState.activeRow === 'firstRow'} onChange={this.setActiveRow}/>
            <label htmlFor="opt1">1:25.000</label></span>
            <div className="showGridHelp" style={{display:parentState.activeRow === 'firstRow'?"flex":"none"}}>
              <input id="opt1_grid" type="checkbox" checked={this.showHelpGrid} onClick={this.toggleHelpGrid} readOnly />
              <label style={{display: "inline-block"}}><Trans i18nKey="step1.seeGrid">Visualizar cuadrículas</Trans></label>
            </div>
          </div>

          <div className="radiobutton-row center scaleOption">
            <span><input type="radio" id="opt2" name="drone" value="secondRow" checked={parentState.activeRow === 'secondRow'} onChange={this.setActiveRow}/>
            <label htmlFor="opt2">1:50.000</label></span>
            <div className="showGridHelp" style={{display:parentState.activeRow === 'secondRow'?"flex":"none"}}>
              <input id="opt2_grid" type="checkbox" checked={this.showHelpGrid} onClick={this.toggleHelpGrid} readOnly />
              <label style={{display: "inline-block"}}><Trans i18nKey="step1.seeGrid">Visualizar cuadrículas</Trans></label>
            </div>
          </div>
        </div></React.Fragment>
        {/* ESCALA */}
        <h2 className="h2Custom fullScreenScaleREF"><Trans i18nKey="step1.scale">Escala</Trans></h2>
        <div className="scale second-step">

          <div className="radiobutton-row center scaleMenu">
            { this.props.parentState.activeRow === 'firstRow' ? (<React.Fragment>
            <Scale scale={parentState.scale} className='small' classNameActive='small active' label='30K' tooltipText='1:30.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            <Scale scale={parentState.scale} className='medium' classNameActive='medium active' label='25K' tooltipText='1:25.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            <Scale scale={parentState.scale} className='large' classNameActive='large active' label='20K' tooltipText='1:20.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            </React.Fragment>) : <React.Fragment>
            <Scale scale={parentState.scale} className='small' classNameActive='small active' label='60K' tooltipText='1:60.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            <Scale scale={parentState.scale} className='medium' classNameActive='medium active' label='50K' tooltipText='1:50.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            <Scale scale={parentState.scale} className='large' classNameActive='large active' label='40K' tooltipText='1:40.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            </React.Fragment>}
          </div>
        </div>
        {/* ORIENTACION MAPA*/}
        <h2 className="h2Custom"><Trans i18nKey="step1.orientation">Orientación</Trans></h2>
        <div className="orientation center third-step">
          <Orientation classNameDiv="horizontal" className="center" src={orientationIMGPaisajeColor} srcChange={orientationIMGPaisajeGris} value={i18n.t('step1.horizontal')} label="Paisaje" checkedI="checked mc-check" selected={parentState.orientation} onClick={this.changeSelectedOrientation}/>
          <Orientation classNameDiv="vertical" className="center" src={orientationIMGRetratoColor} srcChange={orientationIMGRetratoGris} value={i18n.t('step1.vertical')} label="Retrato" checkedI="checked mc-check" selected={parentState.orientation} onClick={this.changeSelectedOrientation}/>
        </div>
        {/* ORIENTACION CARTELA*/}
        <h2 className="h2Custom"><Trans i18nKey="step1.orientationCartela">Orientación cartela</Trans></h2>
        <div className="orientation center cartela-step">
          <Cartela className='medium Cartela' classNameActive='medium Cartela active' src={cartelaVertical} srcChange={cartelaVerticalGris} checkedI="checked mc-check" classNameDiv="horizontal" label={i18n.t('step1.vertical')} selected={!this.enableVertical} onClick={this.toggleVertical}/>
          <Cartela className='medium rotatedCartela' classNameActive='medium rotatedCartela active' src={cartelaHorizontal} srcChange={cartelaHorizontalGris} checkedI="checked mc-check" classNameDiv="vertical" label={i18n.t('step1.horizontal')} selected={this.enableVertical} onClick={this.toggleVertical}/>
        </div>
        {/* CUADRÍCULAS */}
        <h2 className="h2Custom"><Trans i18nKey="step1.grid">Cuadrículas</Trans></h2>

        <div className="orientation center fourth-step">
          <Grid classNameDiv="gridC" className="center" src={gridIMGColor} srcChange={gridIMGGris} label={i18n.t('step1.grid')} checkedI="checked mc-check" selected={parentState.gridFrame} onClick={this.updateFramesValues}/>
          <Grid classNameDiv="cuadriculaC" className="center" src={coordinatesIMGColor} srcChange={coordinatesIMGGris} label={i18n.t('step1.coordinates')} checkedI="checked mc-check" selected={parentState.coordinatesFrame} onClick={this.updateFramesValues}/>
        </div>

        {/* DENSIDAD DE CUADRÍCULA */}
        { this.props.parentState.gridFrame !== '' || this.props.parentState.coordinatesFrame !== '' ? <React.Fragment><h2 className="h2Custom"><Trans i18nKey="step1.cellDimension">Dimensiones de la celda</Trans></h2>

        <div className="orientation center">
          <CellDensity classNameDiv="OneKMC" className="center" src={oneKMColor} srcChange={oneKMGris} value="1 Km" label="1" checkedI="checked mc-check" selected={parentState.cellDensity} onClick={this.changeSelectedCellDensity}/>
          <CellDensity classNameDiv="TwoKMC" className="center" src={twoKMColor} srcChange={twoKMGris} value="2 Km" label="2" checkedI="checked mc-check" selected={parentState.cellDensity} onClick={this.changeSelectedCellDensity}/>
          <CellDensity classNameDiv="FiveKMC" className="center" src={fiveKMColor} srcChange={fiveKMGris} value="5 Km" label="5" checkedI="checked mc-check" selected={parentState.cellDensity} onClick={this.changeSelectedCellDensity}/>
        </div>
        </React.Fragment> : <React.Fragment/>}
      </div>
    </aside>);
  }
}
export default OptionMapSelector;
